import * as Multiselect from '../../../components/blocks/multiselect/main';
import * as Sort        from '../../../components/blocks/sort/main';
import {SelectionModel} from '../../partner/search/filter/partner-selection-model';
import {SearchUrl}      from '../../partner/search/filter/partner-search-url';
import * as SubMenu     from './sub-menu';

const textWidgetElms    = Array.from(document.querySelectorAll('.multiselect')) as HTMLElement[];
const sortWidgetElm     = document.querySelector('.sort')                       as HTMLElement;
const mainElm           = document.querySelector('.product-search')             as HTMLElement;
const selectionModelElm = document.getElementById('selection-model')            as HTMLScriptElement;
const searchButtonElm   = document.getElementById('search-button')              as HTMLButtonElement;
const counterElm        = document.getElementById('search-counter')             as HTMLElement;

let searchUrl           = new SearchUrl(searchButtonElm.dataset.href);
let selectionModel      = new SelectionModel(selectionModelElm, counterElm, searchUrl);


// Update model, counter and active/inactive checkboxes if a checkbox has been selected.
mainElm.addEventListener('checkboxEvent', ((event: CustomEvent) => {
  selectionModel.toggleChecked(event.detail.id);
  updateAllItemStates();
}) as EventListener);

// Update search url if a sort checkbox has been selected.
mainElm.addEventListener('sortCheckboxEvent', ((event: CustomEvent) => {

  const status = event.detail.status as 'init' | boolean;

  searchUrl.sortOrder = 
    (status === true || status === 'init') ? event.detail.parameter : '';

  if (status === true) {
    window.location.href = searchUrl.getUrl()
  }
}) as EventListener);


// Init all multiselect widgets
updateAllItemStates();
for (const widget of textWidgetElms) {
  Multiselect.init(widget);
}

// Init sort widget
Sort.init(sortWidgetElm);

// Init sub menu
SubMenu.partnerSelectionMenu();
SubMenu.partnerSelectionScroll(); 


// Update counter and active/inactive checkboxes based on the model.
function updateAllItemStates() {
  for (let selection of selectionModel.selections) {
    for (let criterion of selection.criteria) {
      const id      = criterion.id.toString();
      const state   = criterion.count != 0;
      const checked = criterion.checked;
      Multiselect.updateItemState(id, state, checked);
    }
  }
  counterElm.innerHTML = selectionModel.activeNodeAmount.toString();
}

// Search button
searchButtonElm.addEventListener('click', () => window.location.href = searchUrl.getUrl());

// Cleanup border lines
const wElm  = document.querySelector('.w-item') as HTMLElement
const items = Array.from(document.querySelectorAll('.results .m-container li')) as HTMLElement[];

if (wElm.style.height == ''){
  wElm.style.border = 'none';
}

if (items.length >= 2 || items.length <= 11 && wElm.style.height == '') {
  items[items.length -2].style.border = 'none';
}


